/*
 *
 * Classes reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_CLASSES,
  LOAD_CLASSES_SUCCESS,
  LOAD_CLASSES_ERROR,
  UPDATE_CLASS,
  UPDATE_CLASS_SUCCESS,
  UPDATE_CLASS_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  loadingUpdate: false,
  classDetail: false,
  itemsList: false,
  firstElem: false,
};

/* eslint-disable default-case, no-param-reassign */
const classesReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_CLASSES:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = false;
        draft.firstElem = false;
        break;

      case LOAD_CLASSES_SUCCESS:
        draft.loading = false;
        draft.firstRender = false;
        draft.itemsList = action.itemsList;
        draft.firstElem = draft.itemsList.data[0];
        break;

      case LOAD_CLASSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        draft.itemsList = false;
        draft.firstElem = false;
        break;

      // Update for Single Class
      case UPDATE_CLASS:
        draft.firstRender = false;
        draft.loadingUpdate = false;
        draft.error = false;
        draft.classDetail = action.classDetail;
        break;

      case UPDATE_CLASS_SUCCESS:
        draft.loadingUpdate = false;
        const { classDetail } = action;
        if (classDetail?._id) {
          draft.classDetail = classDetail;

          let listData = draft.itemsList.data;
          let index = draft.itemsList.data.findIndex(po => po?._id === classDetail?._id);
          index !== -1 ? (listData[index] = classDetail) : listData.unshift(classDetail);
          draft.itemsList = { ...draft.itemsList, data: listData }
        } else { 
          draft.courseDetail = false;
          draft.error = true;
        }
        
        break;

      case UPDATE_CLASS_ERROR:
        draft.error = action.error;
        draft.loadingUpdate = false;
        break;
    }
  });

export default classesReducer;
